import { FieldType, FederalPublicationInfoField } from '../../../components/GenericSection/constants';
import { CONGRESS, START, YEAR_PUBLISHED } from '../../constants';

/** field list for publication federal info section */
export var PUB_FEDERAL_INFO_SECTION_FIELD_LIST = [{
  field: FederalPublicationInfoField.YEAR,
  labelText: YEAR_PUBLISHED,
  recommended: true,
  type: FieldType.TEXT
}, {
  field: FederalPublicationInfoField.CONGRESS,
  labelText: CONGRESS,
  recommended: true,
  type: FieldType.TEXT
}, {
  field: FederalPublicationInfoField.START_PAGE,
  labelText: START,
  type: FieldType.TEXT
}];